export const HOME = '/';
export const LOGIN = '/login';
export const SERVICE = '/service';
export const ABOUT = '/about';
export const CONTACT = '/contact';
export const DOCUMENTS = '/documents';
export const RESOURCES = '/resources';
export const ADMIN = '/admin';
//export const TEXTBOOKS = '/textbooks';
export const PROFEXP = '/professional-experiences';
export const PROFILE = '/profile';
export const SERVICEAPPROVE = '/approval-service';
export const PROFEXPAPPROVE = '/approval-professional';
export const REUNION = '/reunion2025';
export const BINGO = '/bingo';

// extra to help w/ url loading
export const REUNION_SCH = '/reunion2025/schedule';
export const REUNION_GUESTS = '/reunion2025/guests';
export const REUNION_SPEAKERS = '/reunion2025/speakers';
export const REUNION_FAQ = '/reunion2025/faq';